import React from "react"

import { LogoIcon } from './icons'

const HeaderHome = () => (
  <header className={'wisdom-home-header'}>
    <div className={'wisdom-home-logo'}>
      <div>
        <LogoIcon svg={{ height: '2.6em' }}/>
      </div>
    </div>
  </header>
)

export default HeaderHome
